import React from 'react';

const TitleSection = ({ title, backgroundImage }) => {
  const style = backgroundImage ? {
    background: `url('${backgroundImage}') center center / cover no-repeat`
  } : {};

  return (
    <section className="title-section mb-5">
      <div className="title-section-bg" style={style}>
        <div className='container'>
          <h1>{title}</h1>
        </div>
      </div>
    </section>
  );
};

export default TitleSection;